import _defineProperty from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["open", "onOpenChange", "renderAnchor", "anchorRef", "placeholder", "placeholderText", "inputLabel", "selected", "title", "subtitle", "onSelectedChange", "filterValue", "onFilterChange", "items", "textInputProps", "overlayProps", "sx"],
  _excluded2 = ["children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { SearchIcon, TriangleDownIcon } from '@primer/octicons-react';
import React__default, { useCallback, useMemo } from 'react';
import { useId } from '../hooks/useId.js';
import { useProvidedStateOrCreate } from '../hooks/useProvidedStateOrCreate.js';
import { LiveRegion, LiveRegionOutlet, Message } from '../internal/components/LiveRegion.js';
import { useProvidedRefOrCreate } from '../hooks/useProvidedRefOrCreate.js';
import { AnchoredOverlay } from '../AnchoredOverlay/AnchoredOverlay.js';
import Box from '../Box/Box.js';
import Heading from '../Heading/Heading.js';
import { FilteredActionList } from '../FilteredActionList/FilteredActionList.js';
import { ButtonComponent } from '../Button/Button.js';
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function isMultiSelectVariant(selected) {
  return Array.isArray(selected);
}
var focusZoneSettings = {
  // Let FilteredActionList handle focus zone
  disabled: true
};
function SelectPanel(_ref) {
  var open = _ref.open,
    onOpenChange = _ref.onOpenChange,
    _ref$renderAnchor = _ref.renderAnchor,
    renderAnchor = _ref$renderAnchor === void 0 ? function (props) {
      var children = props.children,
        rest = _objectWithoutProperties(props, _excluded2);
      return /*#__PURE__*/React__default.createElement(ButtonComponent, _extends({
        trailingAction: TriangleDownIcon
      }, rest), children);
    } : _ref$renderAnchor,
    externalAnchorRef = _ref.anchorRef,
    placeholder = _ref.placeholder,
    _ref$placeholderText = _ref.placeholderText,
    placeholderText = _ref$placeholderText === void 0 ? 'Filter items' : _ref$placeholderText,
    _ref$inputLabel = _ref.inputLabel,
    inputLabel = _ref$inputLabel === void 0 ? placeholderText : _ref$inputLabel,
    selected = _ref.selected,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? isMultiSelectVariant(selected) ? 'Select items' : 'Select an item' : _ref$title,
    subtitle = _ref.subtitle,
    onSelectedChange = _ref.onSelectedChange,
    externalFilterValue = _ref.filterValue,
    externalOnFilterChange = _ref.onFilterChange,
    items = _ref.items,
    textInputProps = _ref.textInputProps,
    overlayProps = _ref.overlayProps,
    sx = _ref.sx,
    listProps = _objectWithoutProperties(_ref, _excluded);
  var titleId = useId();
  var subtitleId = useId();
  var _useProvidedStateOrCr = useProvidedStateOrCreate(externalFilterValue, undefined, ''),
    _useProvidedStateOrCr2 = _slicedToArray(_useProvidedStateOrCr, 2),
    filterValue = _useProvidedStateOrCr2[0],
    setInternalFilterValue = _useProvidedStateOrCr2[1];
  var onFilterChange = useCallback(function (value, e) {
    externalOnFilterChange(value, e);
    setInternalFilterValue(value);
  }, [externalOnFilterChange, setInternalFilterValue]);
  var anchorRef = useProvidedRefOrCreate(externalAnchorRef);
  var onOpen = useCallback(function (gesture) {
    return onOpenChange(true, gesture);
  }, [onOpenChange]);
  var onClose = useCallback(function (gesture) {
    onOpenChange(false, gesture);
  }, [onOpenChange]);
  var renderMenuAnchor = useMemo(function () {
    if (renderAnchor === null) {
      return null;
    }
    var selectedItems = Array.isArray(selected) ? selected : _toConsumableArray(selected ? [selected] : []);
    return function (props) {
      return renderAnchor(_objectSpread(_objectSpread({}, props), {}, {
        children: selectedItems.length ? selectedItems.map(function (item) {
          return item.text;
        }).join(', ') : placeholder
      }));
    };
  }, [placeholder, renderAnchor, selected]);
  var itemsToRender = useMemo(function () {
    return items.map(function (item) {
      var isItemSelected = isMultiSelectVariant(selected) ? selected.includes(item) : selected === item;
      return _objectSpread(_objectSpread({}, item), {}, {
        role: 'option',
        selected: 'selected' in item && item.selected === undefined ? undefined : isItemSelected,
        onAction: function onAction(itemFromAction, event) {
          var _item$onAction;
          (_item$onAction = item.onAction) === null || _item$onAction === void 0 ? void 0 : _item$onAction.call(item, itemFromAction, event);
          if (event.defaultPrevented) {
            return;
          }
          if (isMultiSelectVariant(selected)) {
            var otherSelectedItems = selected.filter(function (selectedItem) {
              return selectedItem !== item;
            });
            var newSelectedItems = selected.includes(item) ? otherSelectedItems : [].concat(_toConsumableArray(otherSelectedItems), [item]);
            var multiSelectOnChange = onSelectedChange;
            multiSelectOnChange(newSelectedItems);
            return;
          }

          // single select
          var singleSelectOnChange = onSelectedChange;
          singleSelectOnChange(item === selected ? undefined : item);
          onClose('selection');
        }
      });
    });
  }, [onClose, onSelectedChange, items, selected]);
  var inputRef = React__default.useRef(null);
  var focusTrapSettings = {
    initialFocusRef: inputRef
  };
  var extendedTextInputProps = useMemo(function () {
    return _objectSpread({
      sx: {
        m: 2
      },
      contrast: true,
      leadingVisual: SearchIcon,
      'aria-label': inputLabel
    }, textInputProps);
  }, [inputLabel, textInputProps]);
  return /*#__PURE__*/React__default.createElement(LiveRegion, null, /*#__PURE__*/React__default.createElement(AnchoredOverlay, {
    renderAnchor: renderMenuAnchor,
    anchorRef: anchorRef,
    open: open,
    onOpen: onOpen,
    onClose: onClose,
    overlayProps: _objectSpread({
      role: 'dialog',
      'aria-labelledby': titleId,
      'aria-describedby': subtitle ? subtitleId : undefined
    }, overlayProps),
    focusTrapSettings: focusTrapSettings,
    focusZoneSettings: focusZoneSettings
  }, /*#__PURE__*/React__default.createElement(LiveRegionOutlet, null), /*#__PURE__*/React__default.createElement(Message, {
    value: filterValue === '' ? 'Showing all items' : items.length <= 0 ? 'No matching items' : "".concat(items.length, " matching ").concat(items.length === 1 ? 'item' : 'items')
  }), /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      height: 'inherit',
      maxHeight: 'inherit'
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      pt: 2,
      px: 3
    }
  }, /*#__PURE__*/React__default.createElement(Heading, {
    as: "h1",
    id: titleId,
    sx: {
      fontSize: 1
    }
  }, title), subtitle ? /*#__PURE__*/React__default.createElement(Box, {
    id: subtitleId,
    sx: {
      fontSize: 0,
      color: 'fg.muted'
    }
  }, subtitle) : null), /*#__PURE__*/React__default.createElement(FilteredActionList, _extends({
    filterValue: filterValue,
    onFilterChange: onFilterChange,
    placeholderText: placeholderText
  }, listProps, {
    role: "listbox",
    "aria-multiselectable": isMultiSelectVariant(selected) ? 'true' : 'false',
    selectionVariant: isMultiSelectVariant(selected) ? 'multiple' : 'single',
    items: itemsToRender,
    textInputProps: extendedTextInputProps,
    inputRef: inputRef
    // inheriting height and maxHeight ensures that the FilteredActionList is never taller
    // than the Overlay (which would break scrolling the items)
    ,

    sx: _objectSpread(_objectSpread({}, sx), {}, {
      height: 'inherit',
      maxHeight: 'inherit'
    })
  })))));
}
SelectPanel.displayName = "SelectPanel";
SelectPanel.displayName = 'SelectPanel';
export { SelectPanel };